import {
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  Dialog,
  DialogTitle,
  Box,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import jwt_decode from "jwt-decode";
import axios from "axios";
import { baseURL } from "../api/agent";
import { updateToken } from "../redux/reducer/features/Auth/authSlice";
import store from "../redux/store/store";
import { logout } from "../services/auth/auth";
import { Dispatch } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../redux/reducer/rootReducer";

export interface RefreshTokenProps {}

const RefreshToken: React.FunctionComponent<RefreshTokenProps> = () => {
  const userType = useSelector((state: AppState) => state.authReducer.userType);
  const navigate = useNavigate();
  const dispatch = useDispatch<Dispatch<any>>();
  const timeout = 900000;
  const [remaining, setRemaining] = useState(timeout);

  const handleOnActive = () => {
    // intentionally blank
  };
  const handleOnIdle = () => {
    // intentionally blank
  };
  const { getRemainingTime } = useIdleTimer({
    timeout,
    onActive: handleOnActive,
    onIdle: handleOnIdle,
  });

  const [open, setOpen] = React.useState(false);
  const [sessionExpire, setSessionExpire] = React.useState(false);
  const [key, setKey] = React.useState<any>("");

  let interval: any;

  useEffect(() => {
    interval = setInterval(() => {
      if (!sessionExpire) {
        checkForTokenExpire();
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [sessionExpire]);
  useEffect(() => {
    setRemaining(getRemainingTime());

    setInterval(() => {
      setRemaining(getRemainingTime());
    }, 1000);
  }, []);

  useEffect(() => {
    if (remaining <= 0) {
      if (localStorage.getItem("targetWebAccesstoken")) {
        setOpen(true);
      }
    }
  }, [remaining]);

  useEffect(() => {
    setSessionExpire(false);
  }, [key]);

  const handleSignIn = async () => {
    try {
      const res = await axios.post(`${baseURL}api/Account/RefreshToken`, {
        refreshToken: localStorage.getItem("targetWebRefreshtoken"),
      });

      if (res.data && res.data.status === 200) {
        store.dispatch(
          updateToken({
            targetWebAccessToken: res.data.entity.targetWebAccessToken,
            refreshToken: res.data.entity.refreshToken,
          })
        );
        localStorage.setItem(
          "targetWebAccesstoken",
          res.data.entity.targetWebAccessToken
        );
        localStorage.setItem(
          "targetWebRefreshtoken",
          res.data.entity.refreshToken
        );
        setKey(Date.now()); //re init the checking method
        setOpen(false);
      } else {
        handleLogout();
      }
    } catch (refreshError) {
      console.error("Failed to refresh token:", refreshError);
    }
  };

  const handleYes = () => {
    if (localStorage.getItem("targetWebAccesstoken")) {
      let token = localStorage.getItem("targetWebAccesstoken") as string;
      let decoded = jwt_decode(token) as any;
      let currentUTCTime = Math.floor(new Date().getTime() / 1000);
      if (decoded?.exp) {
        if (decoded?.exp < currentUTCTime) {
          // expiring session stops checking for token
          setSessionExpire(true);
          // setting key sets sessionExpire=false, so token gets checked again
          // which refreshes and closes popup
          setKey(Date.now());
        } else {
          setOpen(false);
        }
      } else {
        setOpen(false);
      }
    } else {
      setOpen(false);
    }
  };

  const handleLogout = () => {
    setKey(Date.now());
    dispatch(logout());
    navigate(userType === "Admin" ? "/AdminLogin" : "/Login");
    setOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const checkForTokenExpire = () => {
    if (localStorage.getItem("targetWebAccesstoken")) {
      let token = localStorage.getItem("targetWebAccesstoken") as string;
      let decoded = jwt_decode(token) as any;
      let currentUTCTime = Math.floor(new Date().getTime() / 1000);
      if (decoded?.exp) {
        if (decoded?.exp < currentUTCTime) {
          handleSignIn();
          setSessionExpire(true); // stop the checking while token refreshes
        }
      }
    }
  };

  return (
    <Dialog
      open={open}
      //onClose={handleClose}
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          return; // Prevent closing on backdrop click
        }
        handleClose(); // Allow closing in other cases
      }}
      fullWidth
    >
      <DialogTitle>
        <Box display={"flex"} alignItems={"center"}>
          Your session has expired!
          <WarningAmberIcon
            style={{ marginLeft: 5, color: "#FFCC00", fontSize: "24px" }}
          />
        </Box>
      </DialogTitle>

      <DialogContent>
        <DialogContentText>Do you want to stay signed in ?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" size="small" autoFocus onClick={handleYes}>
          Yes
        </Button>
        <Button variant="outlined" size="small" onClick={handleLogout}>
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RefreshToken;
